import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**Pipe che bypassa il DomSanitizer per visualizzare correttamente il codice html recuperato da BE */
@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  /**
   * Costruttore per SafeHtmlPipe
   * @param sanitized {DomSanitizer}
   */
  constructor(private sanitized: DomSanitizer) {}

  /**
   * Metodo dell'interfaccia PipeTransform che autorizza la resa as is dell'HTML recuperato
   * @param value {any} la stringa HTML da restituire così com'è
   */
  transform(value: any): any {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

}
